<template>
  <div class="flex items-center justify-center w-full h-full rounded-full text-white-900" :style="{ backgroundColor: colour }">
    {{ content }}
  </div>
</template>

<script>
export default {
  name: 'BaseAvatar',

  props: {
    content: {
      type: String,
      required: true
    }
  },

  computed: {
    colour () {
      return this.stringToHslColour(this.content)
    }
  },

  methods: {
    stringToHslColour (value, saturation = 30, lightness = 70) {
      var hash = 0
      for (var i = 0; i < value.length; i++) {
        hash = value.charCodeAt(i) + ((hash << 5) - hash)
      }

      return `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`
    }
  }
}
</script>
